export default "__VITE_ASSET__D$MTCq9G__"